module.exports = __webpack_public_path__ + "img/product-7-guanhuai.b361ceec.png";